import { useState } from 'react';

export function useContractOffice() {
  const [officeQualificationText, setOfficeQualificationText] = useState('');
  const [officeQualificationClient, setOfficeQualificationClient] = useState(null);

  return {
    officeQualificationText, setOfficeQualificationText,
    officeQualificationClient, setOfficeQualificationClient,
  };
}
